import { accreditationsService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { AddAndAcceptAccreditationParams } from 'ogp/services/accreditations-service.types';

export const useAddAndAcceptAccreditation = () => {
  const mutationFn = async ({
    flexWorkerId,
    accreditations,
    startDate,
    expirationDate,
    accreditationType,
  }: AddAndAcceptAccreditationParams) => {
    return await accreditationsService.addAndAcceptAccreditation({
      flexWorkerId,
      accreditations,
      startDate,
      expirationDate,
      accreditationType,
    });
  };

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(QUERY_KEYS.employeeCertificates(variables.flexWorkerId));
    },
  });
};
